import { useMemo } from "react";
import TaxScreen from "static/images/AuthTestimonial/MarketFeature/TaxScreen.svg";
import BooksScreen from "static/images/AuthTestimonial/MarketFeature/BooksScreen.svg";
import PinkStar from "static/images/PinkStar.svg";

export const FeatureMarket = () => {
  const isRandorNumberEven = useMemo(
    () => Math.floor((Math.random() * 10 + 1) % 2),
    []
  );
  const platformDetails = isRandorNumberEven
    ? {
        img: TaxScreen,
        title: "Urgent filing detection with Inkle AI",
        content:
          "Inkle AI reviews your company details and shows exactly the filings you need. Perfect for cross border founders who are new to US taxes and compliance.",
      }
    : {
        img: BooksScreen,
        title: "Instant business insights with Inkle AI",
        content:
          "It calculates your burn rate, cash flow and more. No more manual tracking or number crunching. You get a complete health check of your business in one place.",
      };

  return (
    <div
      className="t-h-full t-w-full t-flex t-flex-col
     t-items-end t-gap-[60px] t-pl-[10%] t-pt-20"
    >
      <div className="t-pl-[9%] t-flex t-flex-col t-gap-3 t-pr-8">
        <div className="t-flex t-gap-1">
          <div className="t-text-body-lg t-font-semibold signin-title">
            {platformDetails.title}
          </div>
          <img src={PinkStar} alt="PinkStar" />
        </div>
        <div className="t-text-body t-text-surface">
          {platformDetails.content}
        </div>
      </div>
      <img
        src={platformDetails.img}
        alt="platformScreen"
        className="t-w-full"
      />
    </div>
  );
};
